import { Navigate, useLocation } from "react-router-dom";

// Client-side fallback for the nginx 301. Reads the live location rather than
// window.location at module scope: App renders once, so a value captured there
// would freeze at whatever the page was loaded with and silently drop filters
// on in-app navigation.
const LibraryRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={{ pathname: "/", search }} replace />;
};

export default LibraryRedirect;
